import animateScrollTo from 'animated-scroll-to';

export const ScrollToId = ( target ) => {
  // const headerHeight = document.getElementById('header').offsetHeight + 10;
  // animateScrollTo(target, {
  //   easing: t => { return t },
  //   // verticalOffset: -headerHeight,
  //   // verticalOffset: window.innerWidth > 700 ? -headerHeight : 0,
  //   speed: 500,
  // });
  const allHrefs = document.querySelectorAll('a');
  const urlHash = location.hash.substr(1);
  // console.log(urlHash);
  // allHrefs.forEach(a => {
  //   if (a.href) {

  //     console.log(a.getAttribute('href'));
  //   }
  // });
  // const allIds = document.querySelectorAll('id');
  const allIds = document.querySelectorAll(`[id^=""]`);
  // console.log(allIds);
  allIds.forEach((id) => {
    if(urlHash === id) {
      id.scrollIntoView();
    }
  })
}
